@if (visible()) {
    <div
        class="rail"
        (pointerdown)="onPointerDown($event)"
        (pointermove)="onPointerMove($event)"
        (pointerup)="onPointerUp($event)"
        (pointercancel)="onPointerUp($event)"
    >
        @for (tick of stopTicks(); track tick.index) {
            <div class="stop-tick" [style.top.px]="tick.topPx"></div>
        }
        <div
            class="viewport-rect"
            [style.top.%]="viewportTopPct()"
            [style.height.%]="viewportHeightPct()"
        ></div>
        @for (dot of vehicleDots(); track dot.inventoryNumber) {
            <div
                class="vehicle-dot"
                [class.warning]="dot.hasWarning"
                [class.going-down]="dot.goingDown"
                [class.going-up]="!dot.goingDown"
                [class.dimmed]="dot.dimmed"
                [style.top.%]="dot.yPercent"
                [style.background-color]="dot.color"
            ></div>
        }
    </div>
}
